import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DataStoreService } from 'src/app/utils/data_store/data-store.service';
import { ApiCallServiceService } from '../api_call_service/api-call-service.service';
import { Observable } from 'rxjs/internal/Observable';
import { PageSize } from 'src/app/enumeration/pageSize';
import { ResponseTypeCheck } from 'src/app/enumeration/response-type';
import { ɵNullViewportScroller } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LmsApiService {

  httt: HttpClient = inject(HttpClient);
  store: DataStoreService = inject(DataStoreService);
  api: ApiCallServiceService = inject(ApiCallServiceService);

  getLMSCouponCodeList(page: any): Observable<any> {
    var url = 'api/lms/coupon/code/listitems?page=' + page + '&pageSize=' + PageSize.DEFAULT_LIST;

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getLMSCourseCatalogList(page: any): Observable<any> {
    var url = 'api/lms/course/catalog/listitems?page=' + page + '&pageSize=' + PageSize.DEFAULT_LIST;

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getLMSCourseCatalogNameList(): Observable<any> {
    var url = 'api/lms/course/catalog/name/list';

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getCreateLMSCourseCatalog(name: any): Observable<any> {
    const url = 'api/lms/course/catalog/create?name=' + name;

    return this.api.postApiCall(
      url,
      ɵNullViewportScroller,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getUpdateLMSCourseCatalog(catalogId: any, name: any): Observable<any> {
    const url = 'api/lms/course/catalog/update?catalogId=' + catalogId + '&name=' + name;

    return this.api.postApiCall(
      url,
      ɵNullViewportScroller,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getEnabledDisabledLMSCourseCatalog(name: any, enabled: any): Observable<any> {
    const url = 'api/lms/course/catalog/enabled?name=' + name + '&enabled=' + enabled;

    return this.api.postApiCall(
      url,
      null,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getLMSCourseItemList(page: any): Observable<any> {
    var url = 'api/lms/course/item/listitems?page=' + page + '&pageSize=' + PageSize.DEFAULT_LIST;

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getCreateLMSCourseItem(name: any, points: any, catalogName: any, redirectUrl: any, description: any): Observable<any> {
    const url = 'api/lms/course/item/create?name=' + name + '&points=' + points + '&catalogName=' + catalogName + '&redirectUrl=' + redirectUrl + '&description=' + description;

    return this.api.postApiCall(
      url,
      null,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getUpdateLMSCourseItem(courseItemId: any, name: any, redirectUrl: any, description: any) {
    const url = 'api/lms/course/item/update?courseItemId=' + courseItemId + '&name=' + name + '&redirectUrl=' + redirectUrl + '&description=' + description;

    return this.api.postApiCall(
      url,
      null,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getRemoveLMSCourseItem(redeemId: any) {
    const url = 'api/lms/course/item/remove?redeemId=' + redeemId;

    return this.api.postApiCall(
      url,
      null,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getEnabledDisabledLMSCourseItem(name: any, enabled: any): Observable<any> {
    const url = 'api/lms/course/item/enabled?name=' + name + '&enabled=' + enabled;

    return this.api.postApiCall(
      url,
      null,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getCreateLMSCouponCode(count: any, point: any, catalogName: any): Observable<any> {
    const url = 'api/lms/coupon/code/create?count=' + count + '&point=' + point + '&catalogName=' + catalogName;

    return this.api.postApiCall(
      url,
      ɵNullViewportScroller,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getEnabledDisabledLMSCouponCode(serialNumber: any, enabled: any): Observable<any> {
    const url = 'api/lms/coupon/code/enabled?serialNumber=' + serialNumber + '&enabled=' + enabled;

    return this.api.postApiCall(
      url,
      null,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getLMSCouponCodeDownloadFile(downloadFileName: any, serialStart: any, serialEnd: any): Observable<any> {
    const url = 'api/lms/coupon/code/download?fileName=' + downloadFileName + '&serialStart=' + serialStart + '&serialEnd=' + serialEnd;

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.TEXT,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getRefundLMSCourseRedeem(redeemId: any) {
    const url = 'api/lms/course/redeem/refund?redeemId=' + redeemId;

    return this.api.postApiCall(
      url,
      null,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getLMSCourseRedeemList(lmsRedeemedStatus: any, startDate: any, endDate: any, page: any): Observable<any> {

    let url = 'api/lms/course/redeem/listitems?lmsRedeemedStatus=' + lmsRedeemedStatus + '&page=' + page + '&pageSize=' + PageSize.DEFAULT_LIST;
    if (startDate && endDate) {
      url = 'api/lms/course/redeem/listitems?lmsRedeemedStatus=' + lmsRedeemedStatus + '&startDate=' + startDate + '&endDate=' + endDate + '&page=' + page + '&pageSize=' + PageSize.DEFAULT_LIST;
    }

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getLMSCourseRedeemListByCustomer(loginPhone: string, lmsRedeemedStatus: any, startDate: any, endDate: any, page: any): Observable<any> {

    let url = 'api/lms/course/redeem/listitems/byCustomer?loginPhone=' + loginPhone + '&lmsRedeemedStatus=' + lmsRedeemedStatus + '&page=' + page + '&pageSize=' + PageSize.DEFAULT_LIST;
    if (startDate && endDate) {
      url = 'api/lms/course/redeem/listitems/byCustomer?loginPhone=' + loginPhone + '&lmsRedeemedStatus=' + lmsRedeemedStatus + '&startDate=' + startDate + '&endDate=' + endDate + '&page=' + page + '&pageSize=' + PageSize.DEFAULT_LIST;
    }

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.JSON,
      ResponseTypeCheck.CONT_JSON,
    );
  }

  getLMSCourseRedeemDownloadFile(fileName: string | null, lmsRedeemedStatus: any, startDate: any, endDate: any): Observable<any> {

    let url = 'api/lms/course/redeem/listitems/downloadcsv?fileName=' + fileName + '&lmsRedeemedStatus=' + lmsRedeemedStatus;
    if (startDate && !endDate) {
      url = 'api/lms/course/redeem/listitems/downloadcsv?fileName=' + fileName + '&lmsRedeemedStatus=' + lmsRedeemedStatus + '&startDate=' + startDate + '&endDate=' + endDate;

    }

    return this.api.getApiCall(
      url,
      ResponseTypeCheck.TEXT,
      ResponseTypeCheck.CONT_JSON,
    );
  }

}

